import React from 'react';
import {inject, observer} from "mobx-react";
import { AxlPanel, AxlButton, AxlCopyLink } from 'axl-reactjs-ui';

import styles, { Container, Label, ExValue } from './styles';
import Moment from "react-moment";

@inject('clientStore')
@observer
class AccountAuth extends React.Component {
  reset = (e) => {
    const { clientStore } = this.props;
    clientStore.resetToken();
  };

  render() {
    const { clientStore } = this.props;
    const { token, restingToken } = clientStore;

    return <Container>
      <AxlPanel>
        <AxlPanel.Row style={styles.Row}>
          <AxlPanel.Col style={styles.Col}>
            <Label style={styles.labelInline}>{`In-use token:`}</Label>
            <AxlCopyLink display={token ? `${token.token.substr(0,4)}*****`: ''} link={token ? token.token: ''} theme={`main`}>{`Copy`}</AxlCopyLink>
          </AxlPanel.Col>
          <AxlPanel.Col style={styles.Col}>
            {token && <Label style={styles.labelInline}>{`Expires: `}<ExValue><Moment interval={0} format={'MM/DD/YYYY @ HH:mm:ss'}>{token.expires * 1000}</Moment></ExValue></Label>}
            <AxlButton loading={restingToken} onClick={this.reset} compact bg={`blueGray`} style={styles.ResetButton}>{`Reset`}</AxlButton>
          </AxlPanel.Col>
        </AxlPanel.Row>
      </AxlPanel>
    </Container>
  }
}

export default AccountAuth;